import React from 'react';
import { useEditorContext } from './EditorContext';
type Props = {
    variableKey: string;
};
const VariablePill: React.FC<Props> = ({ variableKey }) => {
    const { variables, urlSlugs } = useEditorContext();
    const variable = variables.find((v) => v.key === variableKey);
    const isSlug = !variable && urlSlugs.includes(variableKey);
    const isUnknown = !variable && !isSlug;
    const tooltip = variable
        ? `${variable.label} (${variable.owner})`
        : isSlug
          ? `${variableKey} (Mark URL)`
          : `${variableKey} (unknown variable)`;
    return (
        <span
            title={tooltip}
            style={{
                display: 'inline-block',
                padding: '0.1rem 0.5rem',
                borderRadius: '1rem',
                fontWeight: 500,
                backgroundColor: isUnknown ? 'var(--mark-warning-surface)' : 'var(--mark-selected)',
                color: isUnknown ? 'var(--mark-warning)' : 'var(--mark-primary)',
                border: `1px solid ${isUnknown ? 'var(--mark-warning)' : 'var(--mark-border)'}`,
                cursor: 'default'
            }}
        >
            {isUnknown && <span aria-hidden="true">⚠ </span>}
            {`{{${variableKey}}}`}
            {isUnknown && (
                <span
                    style={{
                        marginLeft: '0.3rem'
                    }}
                >
                    unknown
                </span>
            )}
        </span>
    );
};
export default VariablePill;
